// @ts-nocheck
const defaultSize = {
  width: 32,
  height: 32,
};
const themeColor = '#8994dc';
const Time = ({ width = defaultSize.width, height = defaultSize.height }) => (
  <svg
    t="1701242453411"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1798"
    width={width}
    height={height}
  >
    <path
      d="M93.44 514.56a398.08 398.08 0 1 0 796.16 0 398.08 398.08 0 1 0-796.16 0Z"
      fill={themeColor}
      p-id="1799"
    ></path>
    <path
      d="M491.52 926.72C264.96 926.72 80.64 742.4 80.64 515.84c0-226.56 184.32-410.88 410.88-410.88 226.56 0 410.88 184.32 410.88 410.88-1.28 225.28-184.32 410.88-410.88 410.88z m0-797.44c-212.48 0-385.28 172.8-385.28 385.28s172.8 385.28 385.28 385.28 385.28-172.8 385.28-385.28S704 129.28 491.52 129.28z"
      fill={themeColor}
      p-id="1800"
    ></path>
    <path
      d="M183.04 514.56a307.2 307.2 0 1 0 614.4 0 307.2 307.2 0 1 0-614.4 0Z"
      fill="#fff"
      p-id="1801"
    ></path>
    <path
      d="M490.24 834.56c-176.64 0-320-143.36-320-320s143.36-320 320-320 320 143.36 320 320-143.36 320-320 320z m0-614.4c-162.56 0-294.4 131.84-294.4 294.4s131.84 294.4 294.4 294.4 294.4-131.84 294.4-294.4-131.84-294.4-294.4-294.4z"
      fill="#231C1C"
      p-id="1802"
    ></path>
    <path
      d="M477.44 234.24h25.6v35.84h-25.6zM477.44 759.04h25.6v35.84h-25.6zM734.72 501.76h35.84v25.6h-35.84zM209.92 501.76h35.84v25.6h-35.84zM491.52 564.48c-28.16 0-51.2-23.04-51.2-51.2s23.04-51.2 51.2-51.2 51.2 23.04 51.2 51.2-23.04 51.2-51.2 51.2z m0-75.52c-14.08 0-25.6 11.52-25.6 25.6s11.52 25.6 25.6 25.6 25.6-11.52 25.6-25.6-11.52-25.6-25.6-25.6z"
      fill="#231C1C"
      p-id="1803"
    ></path>
    <path
      d="M509.4272 478.6304l159.296-159.296 18.0992 18.0992-159.296 159.296z"
      fill="#231C1C"
      p-id="1804"
    ></path>
    <path d="M477.44 551.68h25.6v128h-25.6z" fill="#231C1C" p-id="1805"></path>
    <path
      d="M318.6304 359.1296l18.0992-18.0992L500.544 504.832l-18.0992 18.0992z"
      fill="#BD3018"
      p-id="1806"
    ></path>
  </svg>
);

const Date = ({ width = defaultSize.width, height = defaultSize.height }) => (
  <svg
    t="1701242139643"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1643"
    width={width}
    height={height}
  >
    <path d="M0 0h1024v1024H0z" fill="#FFFFFF" p-id="1644"></path>
    <path
      d="M340.129 268.868v43.146c0 13.184 10.687 23.871 23.871 23.871 13.052 0 23.657-10.474 23.868-23.476l0.003-0.395-0.001-43.146h257.807v47.92c0 10.434 8.367 18.913 18.758 19.094l0.34 0.003c10.433 0 18.912-8.367 19.093-18.757l0.003-0.34-0.001-47.92h85.73c21.208 0 38.4 17.193 38.4 38.4V766.6c0 21.208-17.192 38.4-38.4 38.4H254.4c-21.208 0-38.4-17.192-38.4-38.4V307.269c0-21.208 17.192-38.401 38.4-38.401h85.729z m362.94 19.2l0.002 28.72-0.006 0.675c-0.36 20.662-17.054 37.287-37.665 37.617l-0.626 0.005-0.674-0.006c-20.662-0.36-37.287-17.054-37.618-37.665l-0.005-0.625v-28.721H407.069l0.001 24.102-0.005 0.55c-0.38 23.494-19.542 42.365-43.065 42.365-23.55 0-42.685-18.9-43.065-42.358l-0.006-0.713v-23.946H254.4c-10.49 0-19.015 8.413-19.2 18.86V766.6c0 10.49 8.412 19.015 18.859 19.2H769.6c10.49 0 19.015-8.412 19.2-18.859V307.27c0-10.49-8.413-19.016-18.859-19.201H703.07z"
      fill="#000"
      p-id="1645"
    ></path>
    <path
      d="M340.129 288.016v23.998c0 13.184 10.687 23.871 23.871 23.871 13.052 0 23.657-10.474 23.868-23.476l0.003-0.395v-23.998h257.806v28.772c0 10.434 8.367 18.913 18.758 19.094l0.34 0.003c10.433 0 18.912-8.367 19.093-18.757l0.003-0.34v-28.772h85.832c10.604 0 19.2 8.597 19.2 19.2v66.912c0 10.604-8.596 19.2-19.2 19.2H254.297c-10.604 0-19.2-8.596-19.2-19.2v-66.912c0-10.603 8.596-19.2 19.2-19.2h85.832z"
      fill={themeColor}
      p-id="1646"
    ></path>
    <path
      d="M407.02 455.914l-0.001 66.633h95.38l0.001-66.633h19.2v66.633h95.38v-66.633h19.2v66.633h99.94v19.2h-99.94v95.685h99.94v19.2h-99.94v61.935h-19.2v-61.935H521.6v61.935h-19.2v-61.935h-95.381v61.935h-19.2v-61.935H268.783v-19.2h119.036v-95.685H268.783v-19.2h119.036v-66.633h19.2z m209.96 181.518v-95.685H521.6v95.685h95.38zM502.4 541.747h-95.381v95.685h95.38v-95.685zM364 211.4c-18.486 0-33.471 14.985-33.471 33.471v67.143c0 18.486 14.985 33.471 33.471 33.471 18.486 0 33.471-14.985 33.471-33.47V244.87c0-18.486-14.985-33.471-33.471-33.471z m0 19.2c7.882 0 14.271 6.39 14.271 14.271v67.143c0 7.882-6.39 14.271-14.271 14.271-7.882 0-14.271-6.39-14.271-14.27V244.87c0-7.882 6.39-14.271 14.271-14.271zM664.774 211.4c-15.849 0-28.697 12.848-28.697 28.697v76.691c0 15.85 12.848 28.697 28.697 28.697 15.849 0 28.697-12.848 28.697-28.697v-76.691c0-15.849-12.848-28.697-28.697-28.697z m0 19.2a9.497 9.497 0 0 1 9.497 9.497v76.691a9.497 9.497 0 0 1-18.994 0v-76.691a9.497 9.497 0 0 1 9.497-9.497z"
      fill="#30699A"
      p-id="1647"
    ></path>
    <path
      d="M406.968 536.934h95.484v105.311h-95.484z"
      fill="#8EBC53"
      p-id="1648"
    ></path>
  </svg>
);

const Week = ({ width = defaultSize.width, height = defaultSize.height }) => (
  <svg
    t="1701241879543"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="8427"
    width={width}
    height={height}
  >
    <path
      d="M104.727273 151.272727h814.545454v837.818182h-814.545454z"
      fill="#FFFFFF"
      p-id="8428"
    ></path>
    <path
      d="M954.181818 1024H69.818182V116.363636h884.363636v907.636364zM139.636364 954.181818h744.727272V186.181818H139.636364v768z"
      fill="#333333"
      p-id="8429"
    ></path>
    <path
      d="M139.636364 186.181818h744.727272v232.727273H139.636364z"
      fill={themeColor}
      p-id="8430"
    ></path>
    <path
      d="M81.454545 395.636364h861.09091v69.818181H81.454545z"
      fill="#333333"
      p-id="8431"
    ></path>
    <path
      d="M311.854545 69.818182c18.618182 0 48.872727 16.290909 60.509091 55.854545 2.327273 9.309091-6.981818 32.581818-13.963636 69.818182-2.327273 13.963636 16.290909 74.472727 6.981818 83.781818-23.272727 25.6-55.854545 30.254545-83.781818 11.636364-4.654545-2.327273-9.309091-9.309091-13.963636-16.290909 0-2.327273-2.327273-4.654545-2.327273-6.981818-4.654545-32.581818-9.309091-55.854545-9.309091-72.145455 0-41.890909 6.981818-67.490909 11.636364-83.781818C274.618182 79.127273 293.236364 69.818182 311.854545 69.818182z"
      fill="#FFFFFF"
      p-id="8432"
    ></path>
    <path
      d="M318.836364 337.454545c-18.618182 0-39.563636-4.654545-55.854546-18.618181-9.309091-6.981818-16.290909-16.290909-25.6-30.254546-2.327273-4.654545-4.654545-9.309091-4.654545-13.963636-6.981818-34.909091-11.636364-60.509091-11.636364-79.127273 0-39.563636 6.981818-67.490909 9.309091-83.781818l2.327273-6.981818c11.636364-51.2 48.872727-69.818182 79.127272-69.818182 34.909091 0 79.127273 27.927273 93.09091 81.454545 4.654545 13.963636 0 27.927273-4.654546 46.545455-2.327273 11.636364-4.654545 23.272727-6.981818 37.236364 0 4.654545 2.327273 16.290909 4.654545 23.272727 6.981818 34.909091 11.636364 60.509091-4.654545 79.127273-20.945455 23.272727-46.545455 34.909091-74.472727 34.90909z m13.963636-67.490909z m-30.254545-6.981818c11.636364 6.981818 20.945455 6.981818 30.254545 0 0-6.981818-2.327273-18.618182-4.654545-25.6-4.654545-23.272727-6.981818-34.909091-4.654546-46.545454 2.327273-18.618182 6.981818-32.581818 9.309091-44.218182 2.327273-4.654545 2.327273-9.309091 2.327273-13.963637-6.981818-20.945455-23.272727-25.6-25.6-27.927272-2.327273 0-6.981818 0-11.636364 13.963636v9.309091c-2.327273 16.290909-6.981818 34.909091-6.981818 67.490909 0 9.309091 2.327273 27.927273 9.309091 65.163636l2.327273 2.327273z m-2.327273-2.327273z m93.090909-60.50909z"
      fill="#333333"
      p-id="8433"
    ></path>
    <path
      d="M707.490909 46.545455c18.618182 0 48.872727 18.618182 60.509091 62.836363 2.327273 11.636364-6.981818 37.236364-13.963636 76.8-2.327273 16.290909 16.290909 83.781818 6.981818 93.090909-23.272727 27.927273-55.854545 32.581818-83.781818 11.636364-4.654545-2.327273-9.309091-9.309091-13.963637-18.618182 0-2.327273-2.327273-4.654545-2.327272-4.654545-4.654545-39.563636-9.309091-65.163636-9.309091-83.781819 0-46.545455 6.981818-74.472727 11.636363-90.763636 6.981818-34.909091 25.6-46.545455 44.218182-46.545454z"
      fill="#FFFFFF"
      p-id="8434"
    ></path>
    <path
      d="M714.472727 337.454545c-18.618182 0-39.563636-6.981818-58.181818-18.618181-9.309091-6.981818-16.290909-16.290909-23.272727-32.581819-2.327273-6.981818-4.654545-11.636364-4.654546-16.290909-6.981818-37.236364-11.636364-67.490909-11.636363-86.109091 0-41.890909 6.981818-72.145455 9.309091-90.763636l2.327272-6.981818c13.963636-69.818182 62.836364-74.472727 79.127273-74.472727 34.909091 0 79.127273 30.254545 93.090909 88.436363 4.654545 13.963636 0 27.927273-4.654545 48.872728-2.327273 11.636364-6.981818 25.6-9.309091 41.890909 0 2.327273 2.327273 18.618182 4.654545 27.927272 6.981818 39.563636 11.636364 65.163636-4.654545 83.781819-18.618182 20.945455-44.218182 34.909091-72.145455 34.90909z m-13.963636-74.472727c4.654545 4.654545 16.290909 9.309091 30.254545 0 0-9.309091-2.327273-23.272727-4.654545-32.581818-4.654545-23.272727-6.981818-37.236364-4.654546-48.872727 2.327273-18.618182 6.981818-34.909091 9.309091-46.545455 2.327273-6.981818 2.327273-13.963636 4.654546-16.290909-6.981818-25.6-20.945455-32.581818-25.6-32.581818-6.981818 0-9.309091 13.963636-9.309091 18.618182l-2.327273 9.309091c-2.327273 16.290909-9.309091 39.563636-9.309091 74.472727 0 13.963636 2.327273 39.563636 9.309091 72.145454l2.327273 2.327273z m0 0z m-2.327273-2.327273z"
      fill="#333333"
      p-id="8435"
    ></path>
    <path
      d="M453.818182 821.527273h-51.2l-88.436364-237.381818 48.872727-18.618182 65.163637 174.545454 58.181818-137.309091 46.545455-2.327272 58.181818 128 79.127272-153.6 46.545455 23.272727-102.4 202.472727h-46.545455L512 679.563636z"
      fill={themeColor}
      p-id="8436"
    ></path>
  </svg>
);

const Image = ({ width = defaultSize.width, height = defaultSize.height }) => (
  <svg
    t="1701243109162"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="9686"
    width={width}
    height={height}
  >
    <path
      d="M665.235 256c42.517 0 70.767 29.918 70.767 74.693v410.614c0 44.876-28.345 74.693-70.767 74.693H134.768c-42.517 0-70.766-29.918-70.766-78.408V330.693c0-48.49 28.25-74.693 70.766-74.693zM298.123 480c-23.587 0-124.35 138.721-178.121 224h504S540.047 565.279 516.55 565.374c-26.303 0-72.048 64.824-73.867 67.417l-0.056 0.08C405.665 593.769 321.62 480 298.123 480z m269.879-168c-31.14 0-56 24.861-56 56s24.86 56 56 56c31.139 0 56-24.861 56-56s-24.861-56-56-56z"
      fill="#2075CC"
      p-id="9687"
    ></path>
    <path
      d="M792.817 246.95l120.6 26.927c48.328 9.334 51.643 20.915 42.609 66.668l-110.631 491.63c-9.168 49.57-20.546 52.994-65.057 43.794l-100.269-18.794 23.83 1.96c22.389 0.782 48.493 1.695 67.836-16.841 19.344-18.537 20.28-45.36 21.082-68.366l-1.339-488.6 1.339-38.379zM253 201.893c7.434-26.943 14.868-61.422 48.522-57.602l212.598 57.602z"
      fill={themeColor}
      p-id="9688"
    ></path>
  </svg>
);

const Video = ({ width = defaultSize.width, height = defaultSize.height }) => (
  <svg
    t="1701243826704"
    className="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1129"
    width={width}
    height={height}
  >
    <path
      d="M896 664H128v216c0 8.85 7.15 16 16 16h736c8.85 0 16-7.15 16-16v-216z"
      fill="#2075cc"
      p-id="1130"
    ></path>
    <path
      d="M170.3 170.3C144.2 196.4 128 232.4 128 272v408h768V272c0-39.6-16.2-75.6-42.3-101.7-26.1-26.1-62.1-42.3-101.7-42.3H272c-39.6 0-75.6 16.2-101.7 42.3z"
      fill="#9da8e1"
      p-id="1131"
    ></path>
    <path
      d="M427 581.8l248.65-143.25c2.95-1.35 5.5-3.55 7.2-6.55 4.4-7.65 1.8-17.45-5.9-21.85l-0.05 0.05-248.6-143.25c-2.6-1.85-5.8-2.95-9.25-2.95-8.85 0-16 7.15-16 16v287.8c-0.05 2.8 0.65 5.6 2.15 8.2 4.4 7.65 14.2 10.3 21.85 5.9l-0.05-0.1z"
      fill="#fff"
      p-id="1132"
    ></path>
    <path
      d="M776 780H248c-8.85 0-16 7.15-16 16s7.15 16 16 16h528c8.85 0 16-7.15 16-16s-7.15-16-16-16z"
      fill="#FFD740"
      p-id="1133"
    ></path>
    <path
      d="M356.15 740c15.45 0 29.45 6.25 39.6 16.4 10.15 10.15 16.4 24.15 16.4 39.6 0 15.45-6.25 29.45-16.4 39.6-10.15 10.15-24.15 16.4-39.6 16.4-15.45 0-29.45-6.25-39.6-16.4-10.15-10.15-16.4-24.15-16.4-39.6 0-15.45 6.25-29.45 16.4-39.6 10.15-10.15 24.15-16.4 39.6-16.4z"
      fill="#263238"
      p-id="1134"
    ></path>
  </svg>
);

const Caption = ({
  width = defaultSize.width,
  height = defaultSize.height,
}) => {
  return (
    <svg
      t="1701249987867"
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="1189"
      width={width}
      height={height}
    >
      <path
        d="M1006.933333 0h-68.266666c-10.24 0-17.066667 6.826667-17.066667 17.066667v68.266666c0 10.24 6.826667 17.066667 17.066667 17.066667h68.266666c10.24 0 17.066667-6.826667 17.066667-17.066667v-68.266666c0-10.24-6.826667-17.066667-17.066667-17.066667zM85.333333 0h-68.266666C6.826667 0 0 6.826667 0 17.066667v68.266666c0 10.24 6.826667 17.066667 17.066667 17.066667h68.266666c10.24 0 17.066667-6.826667 17.066667-17.066667v-68.266666c0-10.24-6.826667-17.066667-17.066667-17.066667zM1006.933333 921.6h-68.266666c-10.24 0-17.066667 6.826667-17.066667 17.066667v68.266666c0 10.24 6.826667 17.066667 17.066667 17.066667h68.266666c10.24 0 17.066667-6.826667 17.066667-17.066667v-68.266666c0-10.24-6.826667-17.066667-17.066667-17.066667zM85.333333 921.6h-68.266666c-10.24 0-17.066667 6.826667-17.066667 17.066667v68.266666c0 10.24 6.826667 17.066667 17.066667 17.066667h68.266666c10.24 0 17.066667-6.826667 17.066667-17.066667v-68.266666c0-10.24-6.826667-17.066667-17.066667-17.066667zM597.333333 785.066667H546.133333V238.933333h204.8v51.2c0 10.24 6.826667 17.066667 17.066667 17.066667s17.066667-6.826667 17.066667-17.066667v-68.266666c0-10.24-6.826667-17.066667-17.066667-17.066667h-477.866667c-10.24 0-17.066667 6.826667-17.066666 17.066667v68.266666c0 10.24 6.826667 17.066667 17.066666 17.066667s17.066667-6.826667 17.066667-17.066667V238.933333h204.8v546.133334h-51.2c-10.24 0-17.066667 6.826667-17.066667 17.066666s6.826667 17.066667 17.066667 17.066667h136.533333c10.24 0 17.066667-6.826667 17.066667-17.066667s-6.826667-17.066667-17.066667-17.066666zM802.133333 34.133333h-102.4c-10.24 0-17.066667 6.826667-17.066666 17.066667s6.826667 17.066667 17.066666 17.066667h102.4c10.24 0 17.066667-6.826667 17.066667-17.066667s-6.826667-17.066667-17.066667-17.066667zM460.8 68.266667h102.4c10.24 0 17.066667-6.826667 17.066667-17.066667s-6.826667-17.066667-17.066667-17.066667h-102.4c-10.24 0-17.066667 6.826667-17.066667 17.066667s6.826667 17.066667 17.066667 17.066667zM221.866667 68.266667h102.4c10.24 0 17.066667-6.826667 17.066666-17.066667S334.506667 34.133333 324.266667 34.133333h-102.4c-10.24 0-17.066667 6.826667-17.066667 17.066667s6.826667 17.066667 17.066667 17.066667zM802.133333 955.733333h-102.4c-10.24 0-17.066667 6.826667-17.066666 17.066667s6.826667 17.066667 17.066666 17.066667h102.4c10.24 0 17.066667-6.826667 17.066667-17.066667s-6.826667-17.066667-17.066667-17.066667zM563.2 955.733333h-102.4c-10.24 0-17.066667 6.826667-17.066667 17.066667s6.826667 17.066667 17.066667 17.066667h102.4c10.24 0 17.066667-6.826667 17.066667-17.066667s-6.826667-17.066667-17.066667-17.066667zM324.266667 955.733333h-102.4c-10.24 0-17.066667 6.826667-17.066667 17.066667s6.826667 17.066667 17.066667 17.066667h102.4c10.24 0 17.066667-6.826667 17.066666-17.066667s-6.826667-17.066667-17.066666-17.066667zM955.733333 802.133333c0 10.24 6.826667 17.066667 17.066667 17.066667s17.066667-6.826667 17.066667-17.066667v-102.4c0-10.24-6.826667-17.066667-17.066667-17.066666s-17.066667 6.826667-17.066667 17.066666v102.4zM955.733333 563.2c0 10.24 6.826667 17.066667 17.066667 17.066667s17.066667-6.826667 17.066667-17.066667v-102.4c0-10.24-6.826667-17.066667-17.066667-17.066667s-17.066667 6.826667-17.066667 17.066667v102.4zM972.8 341.333333c10.24 0 17.066667-6.826667 17.066667-17.066666v-102.4c0-10.24-6.826667-17.066667-17.066667-17.066667s-17.066667 6.826667-17.066667 17.066667v102.4c0 10.24 6.826667 17.066667 17.066667 17.066666zM34.133333 802.133333c0 10.24 6.826667 17.066667 17.066667 17.066667s17.066667-6.826667 17.066667-17.066667v-102.4c0-10.24-6.826667-17.066667-17.066667-17.066666s-17.066667 6.826667-17.066667 17.066666v102.4zM34.133333 563.2c0 10.24 6.826667 17.066667 17.066667 17.066667s17.066667-6.826667 17.066667-17.066667v-102.4c0-10.24-6.826667-17.066667-17.066667-17.066667s-17.066667 6.826667-17.066667 17.066667v102.4zM51.2 341.333333c10.24 0 17.066667-6.826667 17.066667-17.066666v-102.4c0-10.24-6.826667-17.066667-17.066667-17.066667s-17.066667 6.826667-17.066667 17.066667v102.4c0 10.24 6.826667 17.066667 17.066667 17.066666z"
        fill={themeColor}
        p-id="1190"
      ></path>
    </svg>
  );
};

export default {
  Time,
  Date,
  Week,
  Image,
  Video,
  Caption,
};
